﻿window.generateFIO = function () {


    var decEnds_Surname = new Array("швили", "швили", "швили", "швили", "швили", "швили",
        "ский", "ского", "скому", "ского", "ским", "ском",
        "еец", "ейца", "ейцу", "ейца", "ейцем", "ейце",
        "ина", "иной", "иной", "ину", "иной", "иной",
        "дзе", "дзе", "дзе", "дзе", "дзе", "дзе",
        "цой", "цоя", "цою", "цоя", "цоем", "цое",
        "ин", "ина", "ину", "ина", "иным", "ине",
        "ов", "ова", "ову", "ова", "овым", "ове",
        "ев", "ева", "еву", "ева", "евым", "еве",
        "ый", "ого", "ому", "ого", "ым", "ом",
        "ий", "его", "ему", "его", "им", "ем",
        "ой", "ого", "ому", "ого", "ым", "ом",
        "ва", "вой", "вой", "ву", "вой", "вой",
        "ая", "ую", "ой", "ую", "ой", "ой",
        "яя", "юю", "ей", "юю", "ей", "ей",
        "ян", "ян", "ян", "ян", "ян", "ян",
        "д", "да", "ду", "да", "дом", "де");
    var decEnds_Firstname = new Array("ей", "ея", "ею", "ея", "еем", "ее",
        "ел", "ла", "лу", "ла", "лом", "ле",
        "ия", "ии", "ии", "ию", "ией", "ии",
        "ий", "ия", "ию", "ия", "ием", "ии",
        "ль", "ля", "лю", "ля", "лем", "ле",
        "рь", "ря", "рю", "ря", "рем", "ре",
        "ай", "ая", "аю", "ая", "аем", "аи",
        "а", "ы", "е", "у", "ой", "е",
        "в", "ва", "ву", "ва", "вом", "ве",
        "г", "га", "гу", "га", "гом", "ге",
        "д", "да", "ду", "да", "дом", "де",
        "к", "ка", "ку", "ка", "ком", "ке",
        "л", "ла", "лу", "ла", "лом", "ле",
        "м", "ма", "му", "ма", "мом", "ме",
        "н", "на", "ну", "на", "ном", "не",
        "р", "ра", "ру", "ра", "ром", "ре",
        "с", "са", "су", "са", "сом", "се",
        "т", "та", "ту", "та", "том", "те",
        "я", "и", "е", "ю", "ей", "е");
    var decEnds_Patronymic = new Array("ич", "ича", "ичу", "ича", "ичем", "иче",
        "на", "ны", "не", "ну", "ной", "не");

    var instance = {

        ReplaceWordEnd: function (word, decEnds, dec) {
            for (var i = 0; i < decEnds.length; i += 6) {
                var r = new RegExp(".*" + decEnds[i] + "$");
                if (word.match(r) != null)
                    return word.substring(0, word.length - decEnds[i].length) + decEnds[i + dec];
            }
            return word;
        },

        DeclensionFirstname: function (word, declension) {
            return this.ReplaceWordEnd(word, decEnds_Firstname, declension);
        },

        DeclensionSurname: function (word, declension) {
            return this.ReplaceWordEnd(word, decEnds_Surname, declension);
        },

        DeclensionPatronymic: function (word, declension) {
            return this.ReplaceWordEnd(word, decEnds_Patronymic, declension);
        },
        
        setevent: function () {
            console.log("start setevent...");
            document.getElementsByName("fio")[0].addEventListener("focusout", genReportFIO);
        }
    };

    function initials(str) {

        var spl = str.split(/\s+/);

        var newstr = spl[0];
        for (i = 1; i < spl.length; i++) {
            console.log(i);
            if (spl[i].length > 0) {
                newstr = newstr + " " + spl[i][0].toUpperCase() + ".";
                console.log(newstr);
            }
        }
        document.getElementsByName("reportfio")[0].value = newstr;
        return newstr;

        ///TODO
        ///в IE11 map не работает с делегатами такого типа
        //var newstr = str.split(/\s+/).map((w, i) => i ? w.substring(0, 1).toUpperCase() + '.' : w).join(' ');
        //console.log(newstr);
        //document.getElementsByName("reportfio")[0].value = newstr;
    }

    function genReportFIO() {
        initials(document.getElementsByName("fio")[0].value);
    }
    return instance;
}();